import { useState } from "react";
import Lightbox from "./Lightbox";

// Instagram-style masonry-ish grid of images + video reels.
// `items` = [{ type, src, poster? }]
export default function MediaGrid({ items }) {
  const [active, setActive] = useState(null);

  return (
    <>
      <div className="grid grid-cols-2 gap-2 sm:gap-3 md:grid-cols-3 lg:grid-cols-4">
        {items.map((item, i) => (
          <button
            key={item.src}
            onClick={() => setActive(i)}
            className="group relative aspect-square overflow-hidden bg-cream-dark"
          >
            <img
              src={item.type === "video" ? item.poster : item.src}
              alt=""
              loading="lazy"
              className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105"
            />
            <div className="absolute inset-0 bg-charcoal/0 transition-colors duration-500 group-hover:bg-charcoal/25" />
            {item.type === "video" && (
              <span className="absolute right-2 top-2 flex h-7 w-7 items-center justify-center rounded-full bg-charcoal/60 text-cream">
                <svg viewBox="0 0 24 24" className="h-4 w-4" fill="currentColor">
                  <path d="M8 5v14l11-7z" />
                </svg>
              </span>
            )}
            <span className="absolute inset-0 flex items-center justify-center opacity-0 transition-opacity duration-500 group-hover:opacity-100">
              <span className="flex h-11 w-11 items-center justify-center rounded-full border border-gold/80 text-gold">
                <svg viewBox="0 0 24 24" className="h-5 w-5" stroke="currentColor" strokeWidth="1.3" fill="none">
                  <path d="M12 5v14M5 12h14" />
                </svg>
              </span>
            </span>
          </button>
        ))}
      </div>

      <Lightbox
        items={items}
        index={active}
        onClose={() => setActive(null)}
        onNavigate={setActive}
      />
    </>
  );
}
